import { Hint } from "@ui-kit/components/index.es";
import classNames from "classnames";
import Button from "pages/_components/Button";
import FormattedDate from "pages/_components/FormattedDate";
import Heading from "pages/_components/Heading";
import I18n from "pages/_components/I18n";
import Image from "pages/_components/Image";
import InfoTag from "pages/_components/InfoTag";
import Table from "pages/_components/Table";
import RecurrencyContextMenu from "pages/debinPayments/_components/recurrentDebin/RecurrencyContextMenu";
import { arrayOf, bool, func, shape, string } from "prop-types";
import React, { Component } from "react";
import { Modal } from "react-bootstrap";
import Col from "react-bootstrap/lib/Col";
import { connect } from "react-redux";
import { Link } from "react-router-dom";
import { push } from "react-router-redux";
import { actions as debinActions, selectors as debinSelectors } from "reducers/debin";
import { selectors as sessionSelectors } from "reducers/session";
import { accountDescription } from "util/checks";
import * as configUtils from "util/config";
import { statusTagColorRecurrency, statusTagColorRecurrencyV3 } from "util/debin";

const FORM_ID = "debin.recurrency";

class DebinRecurrency extends Component {
    static propTypes = {
        debinRecurrencies: arrayOf(shape({})).isRequired,
        isDesktop: bool,
        accounts: arrayOf(
            shape({
                idProduct: string.isRequired,
            }),
        ).isRequired,
        activeEnvironment: shape({
            permissions: shape({
                debinRecurrencyStatus: bool,
            }),
        }).isRequired,
        dispatch: func.isRequired,
        filters: shape({}).isRequired,
        setSubmitting: func.isRequired,
    };

    static defaultProps = {
        isDesktop: false,
    };

    state = {
        showModal: false,
    };

    getAccountDescription = (cbu) => {
        const { accounts, isDesktop } = this.props;

        const account = accounts.find((a) => a.cbu === cbu);
        if (account?.cbu) {
            const { number, currency, productType } = account;
            let { productAlias } = account;
            let count = 24;
            if (!isDesktop) {
                count = 12;
            }
            productAlias = productAlias && productAlias.slice(0, count) + (productAlias.length > count ? "..." : "");
            return accountDescription(productAlias, number, currency, productType);
        }

        return cbu;
    };

    getEstado = (recurrency) => {
        if (recurrency.estado === "ACTIVA" && recurrency.autorizado === "AUTORIZADO") {
            return "ACTIVA";
        }
        if (recurrency.estado === "INACTIVA" && recurrency.autorizado === "AUTORIZADO") {
            return "INACTIVA";
        }
        if (
            (recurrency.estado === "ACTIVA" || recurrency.estado === "INACTIVA") &&
            recurrency.autorizado === "PENDIENTE"
        ) {
            return "PENDIENTE";
        }
        if (
            (recurrency.estado === "ACTIVA" || recurrency.estado === "INACTIVA") &&
            recurrency.autorizado === "RECHAZADO"
        ) {
            return "RECHAZADO";
        }
        return recurrency.estado;
    };

    receivedDebinAction = () => {
        const { action, recurrency, dispatch } = this.state;
        this.receivedDebinActionArgs(action, recurrency, dispatch);
    };

    receivedDebinActionArgs = (action, debin, dispatch) => {
        dispatch(debinActions.setRecurrencyDebinAction({ action, debin }));
        this.searchSellerCuit(debin?.vendedor?.cuit);

        switch (action) {
            case "ACTIVAR": {
                dispatch(push("/payments/recurrency/action/confirmation"));
                break;
            }
            case "INACTIVAR": {
                dispatch(push("/payments/recurrency/action/confirmation"));
                break;
            }
            case "BLOQUEAR": {
                dispatch(push("/payments/recurrency/action/confirmation"));
                break;
            }
            case "DESACTIVAR": {
                dispatch(push("/payments/recurrency/action/confirmation"));
                break;
            }
            case "AUTORIZAR": {
                dispatch(push("/payments/recurrency/action/confirmation"));
                break;
            }
            case "RECHAZAR": {
                dispatch(push("/payments/recurrency/action/confirmation"));
                break;
            }
            default:
                break;
        }
    };

    searchSellerCuit = (sellerCuit) => {
        const { dispatch } = this.props;

        dispatch(debinActions.debinSeller(sellerCuit));
    };

    showModal = () => {
        this.setState({ showModal: true });
    };

    closeModal = () => {
        this.setState({ showModal: false });
    };

    onConfirmAction = (action, recurrency, dispatch, useApiV3) => {
        const newPendingFunction = configUtils.getBoolean("frontend.show.pendingRecurringDebin.functionalities");
        if (useApiV3 && (action === "ACTIVAR" || action === "AUTORIZAR")) {
            if (newPendingFunction) {
                const transaccion = recurrency.transactions?.find((tx) => tx.action === action);

                if (transaccion) {
                    const { setSubmitting } = this.props;
                    setSubmitting(true);
                    dispatch(debinActions.acceptIncomingRequestPrePending(transaccion?.idTransaction, true));
                } else {
                    this.setState({ showModal: true, action, recurrency, dispatch });
                }
            } else {
                this.setState({ showModal: true, action, recurrency, dispatch });
            }
        } else if (newPendingFunction) {
            const transaccion = recurrency.transactions?.find((tx) => tx.action === action);

            if (transaccion) {
                const { setSubmitting } = this.props;
                setSubmitting(true);
                dispatch(debinActions.acceptIncomingRequestPrePending(transaccion?.idTransaction, true));
            } else {
                this.receivedDebinActionArgs(action, recurrency, dispatch);
            }
        } else {
            this.receivedDebinActionArgs(action, recurrency, dispatch);
        }
    };

    getMessage = (state, object, useApiV3) => {
        if (state === "INACTIVA DEFINITIVA") {
            return "BLOQUEADA";
        }
        if (useApiV3) {
            return this.getEstado(object);
        }
        return state;
    };

    isShow = (object) => {
        const estado = this.getEstado(object);
        let show = false;
        if (estado === "PENDIENTE") {
            show = object?.transactions?.some(
                (transaction) => transaction.action === "AUTORIZAR" || transaction.action === "RECHAZAR",
            );
        } else if (estado === "ACTIVA") {
            show = object?.transactions?.some((transaction) => transaction.action === "DESACTIVAR");
        } else if (estado === "INACTIVA") {
            show = object?.transactions?.some((transaction) => transaction.action === "ACTIVAR");
        } else if (estado === "RECHAZADO") {
            show = object?.transactions?.some((transaction) => transaction.action === "AUTORIZAR");
        }

        return show;
    };

    tableBody = (useApiV3) => {
        const { debinRecurrencies, isDesktop, activeEnvironment, filters } = this.props;

        return debinRecurrencies
            .filter((obj) => {
                if (useApiV3) {
                    return (
                        obj.estado !== "INACTIVA DEFINITIVA" &&
                        (filters?.status === "TODOS" || filters?.status === this.getEstado(obj))
                    );
                }
                return true;
            })
            .map((object) => (
                <Table.Row
                    className="container-white"
                    key={object?.id}
                    renderAs={Link}
                    to={`/payments/recurrent/detail/${object?.id}`}>
                    <Table.Data align="left">
                        <span>{object?.debin?.prestacion}</span>
                    </Table.Data>
                    <Table.Data align="center">
                        <span>{object?.debin?.referencia}</span>
                    </Table.Data>
                    {useApiV3 && (
                        <Table.Data align="center">
                            <FormattedDate date={object?.fecha_creacion} />
                        </Table.Data>
                    )}
                    <Table.Data align="center">
                        <span>{object?.debin?.detalle}</span>
                    </Table.Data>
                    <Table.Data align="center">
                        <span>{object?.vendedor?.cuit}</span>
                    </Table.Data>
                    <Table.Data align="center">
                        <span>{this.getAccountDescription(object?.comprador?.cbu)}</span>
                    </Table.Data>
                    <Table.Data align="center" className="d-flex">
                        {configUtils.getBoolean("frontend.show.pendingRecurringDebin.functionalities") &&
                            this.isShow(object) && (
                                <Hint colorText="dark" colorIcon="dark" text="Pendiente de firmas" />
                            )}
                        <InfoTag
                            type="info"
                            message={this.getMessage(object?.estado, object, useApiV3)}
                            tagBackground={
                                useApiV3
                                    ? statusTagColorRecurrencyV3(this.getEstado(object))
                                    : statusTagColorRecurrency(object.estado)
                            }
                            moreStyles={{
                                color: "#000",
                            }}
                            tagClass={classNames("mx-0 align-self-flex-end mt-35")}
                        />
                    </Table.Data>
                    <Table.Data align="right" className="pr-0">
                        {activeEnvironment.permissions.debinRecurrencyStatus ? (
                            <button type="button" className="btn btn-link p-0" onClick={(e) => e.stopPropagation()}>
                                <RecurrencyContextMenu
                                    recurrency={object}
                                    isDesktop={isDesktop}
                                    contextClass="ml-0 mr-0 debin-recurrency-context"
                                    onConfirmAction={(action, recurrency, dispatch) => {
                                        this.onConfirmAction(action, recurrency, dispatch, useApiV3);
                                    }}
                                />
                            </button>
                        ) : (
                            undefined
                        )}
                    </Table.Data>
                </Table.Row>
            ));
    };

    recurrencyListMobile = (recurrency, useApiV3) => {
        const rPrestacion = recurrency.debin.prestacion;
        const rDetalle = recurrency.debin.detalle;
        const rReferencia = recurrency.debin.referencia;
        const rFechaCreacion = recurrency.fecha_creacion;
        const rCuit = recurrency.comprador.cuit;
        const rCbu = recurrency.comprador.cbu;
        const rEstado = recurrency.estado;
        const rID = recurrency.id;

        const { isDesktop, activeEnvironment } = this.props;

        return (
            <div className="row container-white my-2 mx-0 transfer-component" key={rID}>
                <Col xs={12} className="px-1">
                    <Link to={`/payments/recurrent/detail/${rID}`}>
                        <Col xs={11} className="px-0 py-2">
                            <Col xs={12} className="d-flex space-between pr-0">
                                <Heading.DataGroup
                                    dataClassName="data-desc "
                                    containerClassName="transfer-data wrap data-wrapper-flex debin-detail f-dir-col mt-0"
                                    labelClassName="mb-0 mt-1 small-line"
                                    label={`${FORM_ID}.prestacion`}
                                    data={rPrestacion}
                                />
                                {configUtils.getBoolean("frontend.show.pendingRecurringDebin.functionalities") &&
                                    this.isShow(recurrency) && (
                                        <Hint colorText="dark" colorIcon="dark" text="Pendiente de firmas" />
                                    )}
                                <InfoTag
                                    type="info"
                                    message={this.getMessage(rEstado, recurrency, useApiV3)}
                                    tagBackground={
                                        useApiV3
                                            ? statusTagColorRecurrencyV3(this.getEstado(recurrency))
                                            : statusTagColorRecurrency(rEstado)
                                    }
                                    moreStyles={{ color: "000" }}
                                    tagClass="align-self-start m-0 mt-1"
                                />
                            </Col>
                            <Col xs={12} className="pr-0">
                                <Heading.DataGroup
                                    containerClassName="transfer-data data-wrapper-flex debin-detail mb-0 space-between"
                                    dataClassName="data-desc"
                                    label={`${FORM_ID}.referencia`}
                                    data={rReferencia}
                                />
                            </Col>
                            {useApiV3 && (
                                <Col xs={12} className="pr-0">
                                    <Heading.DataGroup
                                        containerClassName="transfer-data data-wrapper-flex debin-detail mb-0 space-between"
                                        dataClassName="data-desc"
                                        label={`${FORM_ID}.fecha_creacion`}
                                        data={<FormattedDate date={rFechaCreacion} />}
                                    />
                                </Col>
                            )}
                            <Col xs={12} className="pr-0">
                                <Heading.DataGroup
                                    containerClassName="transfer-data data-wrapper-flex debin-detail mb-0 space-between"
                                    dataClassName="data-desc break w-50 text-right"
                                    label={`${FORM_ID}.descripcion`}
                                    data={rDetalle}
                                />
                            </Col>
                            <Col xs={12} className="pr-0">
                                <Heading.DataGroup
                                    containerClassName="transfer-data data-wrapper-flex debin-detail mb-0 space-between"
                                    dataClassName="data-desc"
                                    label={`${FORM_ID}.cuit.vendedor`}
                                    data={rCuit}
                                />
                            </Col>
                            <Col xs={12} className="pr-0">
                                <Heading.DataGroup
                                    containerClassName="transfer-data debin-detail data-wrapper-flex space-between"
                                    dataClassName="data-desc small-font text-align-left"
                                    label={`${FORM_ID}.cuenta`}
                                    data={this.getAccountDescription(rCbu)}
                                />
                            </Col>
                        </Col>
                        <Col xs={1} className="px-0 py-2 transfer-component__header mt-1">
                            {activeEnvironment.permissions.debinRecurrencyStatus ? (
                                <RecurrencyContextMenu
                                    contextClass="no-left"
                                    recurrency={recurrency}
                                    isDesktop={isDesktop}
                                    onConfirmAction={(action, rec, dispatch) => {
                                        this.onConfirmAction(action, rec, dispatch, useApiV3);
                                    }}
                                />
                            ) : (
                                undefined
                            )}
                        </Col>
                    </Link>
                </Col>
            </div>
        );
    };

    render() {
        const { debinRecurrencies, isDesktop, filters } = this.props;

        const useApiV3 = configUtils.getBoolean("frontend.show.RecurringDebin.functionalities", false);
        const { showModal, action } = this.state;
        const recurringbebinAcceptText = configUtils.get("recurringbebin.accept.text", "");
        const recurringbebinAuthorizeText = configUtils.get("recurringbebin.authorize.text", "");
        const getId = () => {
            if (action === "ACTIVAR") {
                return "accept";
            }
            if (action === "AUTORIZAR") {
                return "authorize";
            }
            return "";
        };
        return (
            <>
                <Modal show={showModal} className="fixed-term__modal modal-container">
                    <div className="modal-container debin__recurrent-modal-container">
                        <Modal.Header className="">
                            <Modal.Title>
                                <div className="debin__recurrent-modal-icon">
                                    <Image src="images/warningIcon.svg" className="svg-icon" />
                                </div>
                                <div className="text-center mt-3">
                                    <I18n
                                        componentProps={{ className: `mx-0` }}
                                        id={`debin.recurrency.modal.${getId()}.title`}
                                    />
                                </div>
                            </Modal.Title>
                        </Modal.Header>

                        <Modal.Body className="modal-body">
                            <div className="text-center">
                                {action === "ACTIVAR" && recurringbebinAcceptText}
                                {action === "AUTORIZAR" && recurringbebinAuthorizeText}
                            </div>
                        </Modal.Body>

                        <Modal.Footer style={{ width: "100%" }}>
                            <Button
                                bsStyle="outline"
                                label="global.cancel"
                                block
                                onClick={() => {
                                    this.closeModal();
                                }}
                            />

                            <Button
                                bsStyle="primary"
                                label="global.confirm"
                                block
                                onClick={() => {
                                    this.closeModal();
                                    this.receivedDebinAction();
                                }}
                            />
                        </Modal.Footer>
                    </div>
                </Modal>
                {isDesktop ? (
                    <div className="flex-grow overflow-visible mx-3">
                        <Col className="col col-12 px-0">
                            <div
                                ref={(tableRef) => {
                                    this.child = tableRef;
                                }}
                                className="debin-recurrency-table">
                                <Table>
                                    <Table.Header className="container-white">
                                        <Table.HeaderData align="left">
                                            <I18n id={`${FORM_ID}.prestacion`} />
                                        </Table.HeaderData>
                                        <Table.HeaderData align="center">
                                            <I18n id={`${FORM_ID}.referencia`} />
                                        </Table.HeaderData>
                                        {useApiV3 && (
                                            <Table.HeaderData align="center">
                                                <I18n id={`${FORM_ID}.fecha_creacion`} />
                                            </Table.HeaderData>
                                        )}
                                        <Table.HeaderData align="center">
                                            <I18n id={`${FORM_ID}.descripcion`} />
                                        </Table.HeaderData>
                                        <Table.HeaderData align="center">
                                            <I18n id={`${FORM_ID}.cuit.vendedor`} />
                                        </Table.HeaderData>
                                        <Table.HeaderData align="center">
                                            <I18n id={`${FORM_ID}.cuenta`} />
                                        </Table.HeaderData>
                                        <Table.HeaderData align="right">
                                            <I18n id={`${FORM_ID}.estado`} />
                                        </Table.HeaderData>
                                        <Table.HeaderData width="1rem" />
                                    </Table.Header>
                                    <Table.Body>{this.tableBody(useApiV3)}</Table.Body>
                                </Table>
                            </div>
                        </Col>
                    </div>
                ) : (
                    debinRecurrencies
                        .filter((obj) => {
                            if (useApiV3) {
                                return (
                                    obj.estado !== "INACTIVA DEFINITIVA" &&
                                    (filters?.status === "TODOS" || filters?.status === this.getEstado(obj))
                                );
                            }
                            return true;
                        })
                        .map((debin) => this.recurrencyListMobile(debin, useApiV3))
                )}
            </>
        );
    }
}

const mapStateToProps = (state) => ({
    debinRecurrencies: debinSelectors.getRecurrenciasDebin(state),
    accounts: debinSelectors.getAccounts(state),
    activeEnvironment: sessionSelectors.getActiveEnvironment(state),
    filters: debinSelectors.getFilterRecurrency(state),
});

export default connect(mapStateToProps)(DebinRecurrency);
